import { render } from "./GenericButton.vue?vue&type=template&id=7a715386&scoped=true&ts=true"
import script from "./GenericButton.vue?vue&type=script&lang=ts"
export * from "./GenericButton.vue?vue&type=script&lang=ts"

import "./GenericButton.vue?vue&type=style&index=0&id=7a715386&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a715386"]])

export default __exports__